export default {
  title: 'Instruções para o pagamento',
  paymentType: 'Tipo de pagamento',
  iban: 'IBAN',
  beneficiaryName: 'Nome do beneficiário',
  beneficiaryAddress: 'Endereço do beneficiário',
  expirationDate: 'Data de vencimento',
  multipleDates: 'Introduzir várias datas',
  expiration: 'Vencimento',
  paymentDate: 'Data de pagamento',
  amount: 'Valor',
  addExpirationDate: 'Adicionar nova data de vencimento',
  select: 'Selecione a forma de pagamento',
  expirationDates: {
    title: 'Data de vencimento',
    date: 'Data',
    amount: 'Valor'
  },
  paymentTypes: {
    receipt: 'Recibo domiciliado',
    transfer: 'Transferência',
    issuedEffect: 'Efeito com vencimento',
    effect: 'Efeito',
    promissoryNote: 'Nota promissória',
    check: 'Cheque',
    payment: 'Pagamento domiciliado',
    cash: 'À vista',
    others: 'Outros'
  },
  ft: {
    notRegistered: 'O emissor da fatura não está registrado na "Ficha de Terceros" do Governo de La Rioja. É necessário estar registrado para poder emitir faturas para este organismo. Você pode realizar o processo no seguinte ',
    linkText: 'link.'
  }
}